import {
  getAll,
  getPage,
  getDetail,
} from '@/api/certencodserv'

export default {
  state: {
    state_CertEncod_GetAllResult: null,
    state_CertEncod_GetPageResult: null,
    state_CertEncod_GetDetailResult: null,
  },
  mutations: {
    SET_CERTENCOD_GETALL_RESULT: (state, rst) => {
      state.state_CertEncod_GetAllResult = rst;
    },
    SET_CERTENCOD_GETPAGE_RESULT: (state, rst) => {
      state.state_CertEncod_GetPageResult = rst;
    },
    SET_CERTENCOD_GETDETAIL_RESULT: (state, rst) => {
      state.state_CertEncod_GetDetailResult = rst;
    },
  },
  actions: {
    CertEncodServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CERTENCOD_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CERTENCOD_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CertEncodServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CERTENCOD_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CERTENCOD_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CertEncodServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CERTENCOD_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CERTENCOD_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_CertEncod_GetAllResult: state => {
      return state.state_CertEncod_GetAllResult;
    },
    get_CertEncod_GetPageResult: state => {
      return state.state_CertEncod_GetPageResult;
    },
    get_CertEncod_GetDetailResult: state => {
      return state.state_CertEncod_GetDetailResult;
    },
  }
}